const translateAggregationsPaths = {
  'activityType.activity': 'experienceTypes',
  'subcategory.items[]': 'subcategories',
  'duration.items[]': 'durationRanges',
  'languages.items[]': 'languages',
  'price.items[]': 'priceRanges',
  'tags.items[]': 'tagsBySubCategory',
  'family-friendly': 'is_family_friendly',
  'other.transport_mode.items[]': 'transport_mode',
};

export const activitiesKeys = [
  'sports-leisure',
  'cooking-classes',
  'workshops',
  'home-dinners',
  'tastings',
  'wildlife-nature',
];

export function areThereResults(
  aggregations,
  category,
  key = null,
  showUnknownCategoriesAsAvailable = false,
  subcategory = null,
) {
  if (!aggregations) {
    // we do not have searchResults yet, don't render links
    return false;
  }
  if (!translateAggregationsPaths[category]) {
    // this category is not in aggregations, don't render links
    return showUnknownCategoriesAsAvailable;
  }
  if (
    !aggregations[translateAggregationsPaths[category]] ||
    !aggregations[translateAggregationsPaths[category]].buckets
  ) {
    // aggregations from server doesn't include this category
    return false;
  }
  const aggregationPath = translateAggregationsPaths[category];
  const highestLevelItems = aggregations[aggregationPath].buckets;
  let overallCount = 0;
  for (const item of highestLevelItems) {
    if (aggregationPath.startsWith('is_') && item.key === 'T') {
      return item.doc_count > 0;
    }
    if (item.key && item.key === key) {
      return item.doc_count > 0;
    }
    if (item.tags && item.tags.buckets) {
      if (
        !subcategory ||
        item.key === subcategory ||
        (subcategory === 'activities' && activitiesKeys.includes(item.key))
      ) {
        for (const tag of item.tags.buckets) {
          if (tag.key && tag.key === key) {
            return tag.doc_count > 0;
          }
        }
      }
    }
    overallCount += item.doc_count;
  }
  if (!key) {
    return overallCount > 0;
  }
  return false;
}

export function shouldThisTagBeShown(
  aggregations,
  selectedSubcategories,
  uid,
  value,
  subcategory,
) {
  return (
    areThereResults(aggregations, uid, value, false, subcategory) ||
    (selectedSubcategories &&
      selectedSubcategories.subOptions &&
      selectedSubcategories.subOptions.some((s) => s.value === value))
  );
}

export function getSubcategoryFromFilters(selectedCategories = []) {
  const subcategories = selectedCategories.filter(
    (f) => f.uid === 'subcategory.items[]',
  );
  return subcategories?.[0]?.subOptions?.[0]?.value ?? null;
}
